import React from 'react';
import Stack from '../stack';

interface FilterTab {
  id: string;
  label: string;
}

interface FilterTabsProps {
  options: FilterTab[];
  selected: string;
  onChange: (id: string) => void;
}
const baseClasses = [
  'tw-px-[12px]',
  'tw-py-[8px]',
  'tw-rounded-full',
  'tw-border',
  'tw-border-solid',
  'tw-border-neutral-300',
  'tw-cursor-pointer',
  'tw-select-none'
].join(' ');

const selectedClasses = [
  'tw-bg-[hsl(var(--color-primary-hue),var(--color-primary-saturation),95%)]',
  'tw-text-blue-custom',
  '!tw-border-blue-dull',
  'tw-font-medium'
].join(' ');

const FilterTabs = ({ options, selected, onChange }: FilterTabsProps) => {
  return (
    <Stack direction="row" gap={2}>
      {options.map((option) => {
        const isSelected = option.id === selected;

        const classNames = `${baseClasses} ${isSelected ? selectedClasses : ''}`;
        return (
          <div key={option.id} className={classNames} onClick={() => onChange(option.id)}>
            {option.label}
          </div>
        );
      })}
    </Stack>
  );
};

export default FilterTabs;
